import { useAuth } from "@/context/AuthContext";
import UserDashboard from "@/pages/UserDashboard";
import CourierDashboard from "@/pages/CourierDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import OperationsDashboard from "@/pages/OperationsDashboard";
import DashboardShell from "@/components/DashboardShell";
import { SourceProvider, useSource } from "@/context/SourceContext";
import SourceSelectDialog from "@/components/SourceSelectDialog";

function DashboardInner() {
  const { user } = useAuth();
  const { source } = useSource();
  const gated = ["admin", "operations", "courier"].includes(user?.role);
  return (
    <DashboardShell>
      {gated && !source ? (
        <SourceSelectDialog />
      ) : (
        <>
          {user?.role === "admin" && <AdminDashboard />}
          {user?.role === "courier" && <CourierDashboard />}
          {user?.role === "operations" && <OperationsDashboard />}
          {user?.role === "user" && <UserDashboard />}
        </>
      )}
    </DashboardShell>
  );
}

export default function DashboardRouter() {
  return (
    <SourceProvider>
      <DashboardInner />
    </SourceProvider>
  );
}
